import { render, staticRenderFns } from "./AttendancePostCreate.vue?vue&type=template&id=32931ec8"
import script from "./AttendancePostCreate.vue?vue&type=script&lang=js"
export * from "./AttendancePostCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports